const SiteUrl = window.location.protocol + '//' + window.location.host;
export const PolicySummaryPage = SiteUrl + '/group/insured/policy-summary';
export const AddPolicyPage = SiteUrl + '/group/insured/add-policy';
export const MobileAppUrl = 'thesilverlining://regSuccess';
